import { getTodoListNode } from "./nodes/todoList";
import { getTodoListItemNode } from "./nodes/todoListItem";
const getListAttrs = dom => {
  let result = {};
  return result;
};
const setListAttrs = () => {};
const todoNodes = options => {
  return {
    todo_list: getTodoListNode(options),
    todo_list_item: getTodoListItemNode(options)
  };
};
export { getListAttrs, setListAttrs, todoNodes };